import React, { useEffect, useMemo, useRef, useState } from 'react';

import { IonIcon, IonTitle } from '@ionic/react';
import { timeOutline } from 'ionicons/icons';

import './index.css';

const RelativeUploadedTime = ({ dataUpdatedAt }: any) => {
  const mounted = useRef(true);
  const [refreshCounter, setRefreshCounter] = useState(false);
  const relativeChartUpdateDate = useMemo(() => {
    if (!dataUpdatedAt) {
      return null;
    }
    const deltaSeconds = (Date.now() - dataUpdatedAt) / 1000;
    const deltaMinutes = deltaSeconds / 60;
    const deltaHours = deltaMinutes / 60;
    const deltaDays = deltaHours / 24;

    if (Math.floor(deltaHours) === 0) {
      return '';
    }
    if (deltaHours < 24) {
      return `Data loaded ${Math.floor(deltaHours)} hour${
        deltaHours > 1 ? 's' : ''
      }`;
    }
    return `Data loaded ${Math.floor(deltaDays)} day${
      deltaDays > 1 ? 's' : ''
    }`;
  }, [dataUpdatedAt, refreshCounter]);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    Promise.resolve().then(async () => {
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (mounted.current) {
        setRefreshCounter(!refreshCounter);
      }
    });
  }, [refreshCounter]);

  return relativeChartUpdateDate ? (
    <div className={'RelativeUploadedTime'}>
      <IonIcon icon={timeOutline} />
      <IonTitle color={'medium'}>{relativeChartUpdateDate}</IonTitle>
    </div>
  ) : null;
};

export default RelativeUploadedTime;
